import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { CollectionCard } from '../ui/CollectionCard';
import { ScrollReveal } from '../ui/ScrollReveal';
import { Link } from 'react-router-dom';
export function FeaturedCollections() {
  return <section className="py-20 md:py-32 bg-[#FFF8F0]" data-id="element-30">
      <div className="container mx-auto px-4 md:px-8" data-id="element-31">
        <ScrollReveal data-id="element-32">
          <SectionHeading title="The Collections" withStripe className="mb-16" data-id="element-33" />
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-6xl mx-auto" data-id="element-34">
          <ScrollReveal direction="up" delay={100} data-id="element-35">
            <CollectionCard name="The Butter Basics" tagline="Your forever, signature collection." imageLabel="Classic gold + silver chains laid flat" shopUrl="https://shop.butter-blonde.com/collections/basics" data-id="element-36" />
          </ScrollReveal>

          <ScrollReveal direction="up" delay={300} data-id="element-37">
            <CollectionCard name="Stacked in Butter" tagline="Your brand's personality lives here." imageLabel="Playful layered necklace stack on a neck" shopUrl="https://shop.butter-blonde.com/collections/stacked" data-id="element-38" />
          </ScrollReveal>
        </div>

        <ScrollReveal delay={500} data-id="element-39">
          <div className="mt-16 text-center" data-id="element-40">
            <Link to="/collections" className="inline-flex items-center font-body font-bold text-[#E91E8C] hover:text-[#6B1D4A] transition-colors text-lg group" data-id="element-41">
              View All Collections
              <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-42">
                →
              </span>
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}